var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "发券列表",
        visible: _vm.dialogVisible,
        width: "880px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.couponList,
            border: "",
            height: "600",
            "show-summary": "",
            "summary-method": _vm.getSummaries,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "shopName", label: "客户名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sendNumber", label: "发券数量", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "usedNumber", label: "已用", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sendShopName", label: "发券人", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "collectionTime", label: "发券时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRevoke(scope.row)
                          },
                        },
                      },
                      [_vm._v("撤回")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }